export default __webpack_public_path__ + "static/media/Brokof-100-ml-ban.218a11cd.jpg";